import type { Context } from "react";
import { use } from "react";
import { defined } from "../utilities/typeHelper";

const useDefinedContext = <P>(context: Context<P | undefined>, contextName?: string): P =>
  defined(use(context), `Attempt to use ${contextName || "a context"} without provider`);

export default useDefinedContext;
